import React, { useEffect, useState } from 'react';
import Creatable, { useCreatable } from 'react-select/creatable';
import { extractValues } from '../../Helper/helper';
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { authAxios } from '../../config/config';
import { toast } from 'react-toastify';

const AddFaq = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
    const [formData, setFormData] = useState({
        question: { en: '', ar: '' },
        answer: { en: '', ar: '' },
        isActive: true
    });

    const handleInputChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [lang]: value
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            question: {
                en: formData.question.en,
                ar: formData.question.ar
            },
            answer: {
                en: formData.answer.en,
                ar: formData.answer.ar
            },
            isActive: formData?.isActive
        }

        if (allmodel?.data?._id) {
            handleUpdate(payload)
        } else {
            handleAdd(payload)
        }


    };

    const fields = [
        { key: 'question', label: 'Question' },
        { key: 'answer', label: 'Answer' },
    ];




    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        await authAxios()
            .post("/admin/upload/single", formData)
            .then((response) => {
                const resData = response.data;
                console.log("handleProfileChange", resData)
                toast.success(resData.message);
                setFormData((prev) => ({
                    ...prev,
                    image: resData.data.url
                }))
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
    };



    useEffect(() => {
        if (allmodel && allmodel?.data?._id) {
            setFormData((prev) => ({
                ...prev,
                question: {
                    en: allmodel?.data?.question.en,
                    ar: allmodel?.data?.question.ar
                },
                answer: {
                    en: allmodel?.data?.answer.en,
                    ar: allmodel?.data?.answer.ar
                },
            }))
        }

    }, [])

    return (
        <div className="fixed inset-0 z-10">

            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6"> {allmodel?.data?._id ? <>Update Faq </> : <>Add Faq</>} </h2>
                            <div className="flex items-center gap-4">
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2"></label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">English </label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">Arabic</label>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {fields.map(({ key, label }) => (
                                    <div key={key} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">{label}</label>

                                        <input
                                            type="text"
                                            placeholder={`${label} (EN)`}
                                            required
                                            value={formData[key]?.en || ''}
                                            onChange={(e) =>
                                                handleInputChange(key, 'en', e.target.value)
                                            }
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${label} (AR)`}
                                            value={formData[key]?.ar || ''}
                                            onChange={(e) =>
                                                handleInputChange(key, 'ar', e.target.value)
                                            }
                                            required
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}




                              

                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                                    >
                                        Cancel
                                    </button>
                                    {
                                        allmodel?.data?._id ? <button
                                            type="submit"
                                            className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                        >
                                            Update
                                        </button> : <button
                                            type="submit"
                                            className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                        >
                                            Add
                                        </button>
                                    }

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddFaq;
